"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promosEmptyValuesCreator = void 0;
const date_fns_1 = require("date-fns");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
const types_1 = require("../../../../../types");
const now = new Date();
const baseEmptyValues = {
    item: mui_inputs_asset_1.emptyItem,
    price: mui_inputs_asset_1.emptyPrice,
    startTimestamp: (0, date_fns_1.addMonths)(now, 0).toISOString(),
    endTimestamp: (0, date_fns_1.addMonths)(now, 1).toISOString(),
};
const promosEmptyValuesCreator = profile => ({
    [types_1.ServiceType.ADMIN]: {
        ...baseEmptyValues,
    },
    [types_1.ServiceType.OFFICE]: {
        ...baseEmptyValues,
        merchantId: profile.merchantId,
    },
});
exports.promosEmptyValuesCreator = promosEmptyValuesCreator;
//# sourceMappingURL=schemas.js.map